import { Link } from 'react-scroll';
import './NavBar.css';

const navSections = [
  { to: 'about', label: 'About' },
  { to: 'focus', label: 'Focus' },
  { to: 'connect', label: 'Connect' },
];

const scrollProps = {
  smooth: true,
  duration: 500,
  offset: -64,
};

function NavBar() {
  return (
    <nav className="site-nav" aria-label="Primary">
      <Link to="hero" smooth duration={500} className="site-nav__brand">
        &lt;SMALLPHISH /&gt;
      </Link>
      <ul className="site-nav__links">
        {navSections.map(({ to, label }) => (
          <li key={to}>
            <Link
              {...scrollProps}
              to={to}
              spy
              activeClass="site-nav__link--active"
              className="site-nav__link"
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default NavBar;
